{
  "hangarsPresenter": {
    "title": "Hangars – {{fboName}}",
    "stats": {
      "totalHangars": "Hangars au total",
      "totalAircraft": "Aéronefs dans les hangars"
    },
    "columns": {
      "hangarName": "Nom du hangar",
      "aircraft": "Aéronef",
      "utilization": "Utilisation",
      "estValue": "Valeur est.",
      "estTowTime": "Tps remor.",
      "lastStacked": "Dern. empil.",
      "actions": "Actions"
    },
    "tooltips": {
      "aircraftCount": "# aéronefs dans le hangar / # aéronefs souhaités à l'intérieur",
      "utilization": {
        "title": "Utilisation",
        "stacked": "<strong>Empilé</strong> affiche l'utilisation actuelle, qui peut dépasser 100 % lorsque des aéronefs sont stationnés dans l'espace négatif du gabarit d'autres aéronefs.",
        "fullLoad": "<strong>À pleine capacité</strong> indique le taux d'utilisation si tous les aéronefs affectés à ce hangar étaient au sol simultanément.",
        "gauge": "L'indicateur affiche un repère de référence à 100 % - bleu en dessous, vert au-dessus.",
        "adjust": "Ajustez le mode de calcul dans Paramètres → Configuration"
      },
      "estValue": "Valeur estimée du hangar par nuit selon les aéronefs entièrement à l'intérieur du hangar",
      "estValueBreakdown": "Base: ${{base}} | Trans: ${{transient}}",
      "estTowTime": "Temps estimé pour positionner le hangar de remorquage"
    },
    "emptyState": {
      "title": "Aucun hangar",
      "description": "Créez votre premier hangar pour commencer à gérer le stockage et les opérations de placement des aéronefs."
    }
  },
  "utilizationDisplay": {
    "stacked": "empilé",
    "atFullTenantLoad": "à pleine charge locataire"
  },
  "multiHangarSelector": {
    "label": "Hangars",
    "selectAll": "Tout sélect.",
    "goButton": "Go",
    "noHangars": {
      "primary": "Aucun hangar disponible",
      "secondary": "Créez d'abord un hangar pour utiliser cette fonctionnalité"
    }
  },
  "hangarRow": {
    "aircraftCount": "{{inside}} / {{total}} aéronefs",
    "lastStacked": {
      "tooltip": "Date de la dernière opération de pile",
      "never": "Jamais"
    },
    "buttons": {
      "currentHangar": "Hangar actuel",
      "hangarSchedule": "Calendrier du hangar",
      "editTenants": "Modifier locataires"
    }
  }
}
